import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Tailwind class merger (shadcn/ui convention).
 * Usage: cn('px-2 py-1', condition && 'bg-red-500')
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function fmtMoney(n) {
  return Number(n || 0).toFixed(2)
}

export function fmtDate(d) {
  if (!d) return '-'
  try {
    return new Date(d).toLocaleDateString('es-CO')
  } catch {
    return '-'
  }
}
